import { $cdn } from '../y/cdn';
import { $color } from './color';
import { UIBackground } from './types';
import { UIViewSpec } from './view';

export function uiIsLightBG(bg: UIBackground) {
    if(bg.color) {
        return $color.isLight($color.make(bg.color));
    } else if(bg.gradient) {
        return $color.isLight($color.make(bg.stops[0][0]));
    }

    return;
}

export function uiSetBG(what: UIViewSpec, bg: UIBackground = {}) {
    const elem = what.ui_elem;

    if(bg.color) {
        elem.style.background = bg.color;
    } else if(bg.gradient) {
        if(bg.gradient == 'linear') {
            let value = 'linear-gradient(';
            if(bg.angle)
                value += `${bg.angle}deg, `;
            value += bg.stops.map(s => s[1] ? `${s[0]} ${s[1]}` : s[0]).join(',');
            elem.style.background = value + ')';
        }
    } else if(bg.media || bg.url || bg.cdn) {
        let url = bg.url ?? (bg.cdn != undefined ? $cdn(bg.cdn) : $cdn.media(bg.media!, bg.variant))

        let value = `url(${url}) ${bg.pos || 'center'} / ${bg.size || 'cover'} no-repeat`;
        if(bg.overlay)
            value = bg.overlay + ',' + value;

        if(bg.query) {
            elem.ui_setQueryStyle(bg.query, 'background', value);
        } else {
            elem.style.background = value;
        }
    } else if(bg.special) {
        elem.style.background = '';
        elem.classList.add('bg-special-' + bg.special);
    } else {
        elem.style.background = '';
    }
}
